<template>
  <div class="flow-button">
    <div v-if="showList" class="background-container" @click="onShowList"></div>
    <div class="btn-container" @click="onShowList">
        <div v-if="!action" class="plus-btn">
        <img src="@/assets/images/add.png" class="add-icon" alt="add" />
      </div>
    
      <call-flow-button-icon
        v-else
        :action="action"
        :names="itemName"
        :enabledRouting="typeof target === 'number' ? true : target.isEnabled"
          :showList= "showList"
        isDisp = "1"
        isEnabled="1"
        
        
        type="large"
        @click="onShowList"
        @edit-recording="editRecording"
      />
    </div>

    <div v-if="showList" class="list">
      <div class="section-title">
        Steps
      </div>

      <div v-if="!callMenu" class="list-item" @click="onClickItem(ACTION_TYPES.ACTION_MENU, null)">
        <call-flow-button-icon :action="ACTION_TYPES.ACTION_MENU" />
        <span class="item-name">Call menu</span>
      </div>

      <span v-if="!callMenu" class="section-title" style="margin-top: 10px;">
        Result
      </span>

      <div class="list-item" @mouseover="hoverPerson = true" @mouseleave="hoverPerson = false">
        <call-flow-button-icon :action="ACTION_TYPES.ACTION_PERSON" />
        <span class="item-name">Call a person</span>
        <img src="@/assets/images/next.png" style="width: 7px; height: 12px;" />

        <div v-if="hoverPerson" class="list more">
          <div
            v-for="(person, index) in team"
            :key="index"
            class="list-item"
            @click="onClickItem(ACTION_TYPES.ACTION_PERSON, person.id)"
          >
            <div class="item-avatar" :style="'background-color: ' + person.avatarColor">
              {{ person.avatarName }}
            </div>
            <div class="item-name">
              {{ person.name }}
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="groups.filter((group) => group.isCreated == true).length > 0"
        class="list-item"
        @mouseover="hoverGroup = true"
        @mouseleave="hoverGroup = false"
      >
        <call-flow-button-icon :action="ACTION_TYPES.ACTION_GROUP" />
        <span class="item-name">Call group</span>
        <img src="@/assets/images/next.png" style="width: 7px; height: 12px;" />

        <div v-if="hoverGroup" class="list more">
          <div
            v-for="(group, index) in groups"
            :key="index"
            class="list-item"
            @click="onClickItem(ACTION_TYPES.ACTION_GROUP, group.id)"
          >
            <div class="item-avatar" :style="'background-color: ' + group.avatarColor">
              {{ group.avatarName }}
            </div>
            <div class="item-name">
              {{ group.name }}
            </div>
          </div>
        </div>
      </div>

      <div class="list-item" @click="onClickItem(ACTION_TYPES.ACTION_VOICEMAIL, null)">
        <call-flow-button-icon :action="ACTION_TYPES.ACTION_VOICEMAIL" />
        <span class="item-name">Send to voicemail</span>
      </div>

      
    </div>
  </div>
</template>

<script>
import { ACTION_TYPES } from '@/constants';
import CallFlowButtonIcon from './CallFlowButtonIcon';

export default {
  name: 'CallFlowButton',
  components: { CallFlowButtonIcon },
  props: {
    team: Array,
    groups: Array,
    action: String,
    type: String,
    target: [String, Number, Object],
    callMenu: {
      type: Boolean,
      require: false,
      default: false
    },
    callMenuNumber: {
      required: false,
      type: Number
    }
  },
  data() {
    return {
      showList: false,
      hoverPerson: false,
      hoverGroup: false,
      ACTION_TYPES
    };
  },
  computed: {
    itemName() {
            console.log(this.target)
   
   
   
      if (this.action === ACTION_TYPES.ACTION_GROUP) {


        const group = this.groups.find((grp) => grp.id === this.target.id || grp.id === this.target);

        console.log(this.groups);
        return [group.name];
      }
      if (this.action === ACTION_TYPES.ACTION_PERSON) {
        const person = this.team.find((el) => el.id == this.target || el.id == this.target.id);
        return [person.firstName, person.lastName];
      }
      if (this.action === ACTION_TYPES.ACTION_VOICEMAIL) {
        return ['Voicemail'];
      }
      if (this.action === ACTION_TYPES.ACTION_HANGUP) {
        return ['Hang up'];
      }
      return [];
    }
  },
  methods: {
    editRecording() {
                         
      return this.$emit('select-action', this.action, null, this.type, this.callMenuNumber, true);
    },
    editNotes() {},
    onShowList() {
      this.showList = !this.showList;
    },
    /**
     * Select the action
     * @param action {string} - selected action
     * @param data {*} - corresponding data
     * @returns {*}
     */
    onClickItem(action, data) {
      this.showList = false;
      this.hoverPerson = false;
      this.hoverGroup = false;
      this.$emit('delete-target', action, data, this.type, this.callMenuNumber);
      return this.$emit('select-action', action, data, this.type, this.callMenuNumber,  false);
    }
  }
};
</script>

<style scoped lang="scss">
.flow-button {
  width: 46px;
  height: 46px;

  .steps-name {
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    letter-spacing: -0.01em;
    color: $colorText;
  }

  .background-container {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
  }

  .btn-container {
    cursor: pointer;

    .plus-btn {
      width: 46px;
      height: 46px;
      background: #ffffff;
      border: 0.2px solid #d4d6d8;
      box-sizing: border-box;
      box-shadow: 0 2px 10px rgba(83, 95, 119, 0.15), 0 3px 2px rgba(83, 95, 119, 0.2);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .add-icon {
        width: 22px;
        height: 22px;
      }
    }
  }

  .list {
    position: absolute;
    left: 75px;
    bottom: 0;
    width: 290px;
    background: #ffffff;
    border: 0.2px solid #d4d6d8;
    box-shadow: 2px 2px 10px rgba(83, 95, 119, 0.15);
    border-radius: 10px;
    padding: 10px 0;
    z-index: 100;

    &.more {
      left: 272px;
      top: 0;
      bottom: unset;
      max-height: 250px;
      overflow: auto;
    }

    .section-title {
      display: block;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: -0.01em;
      color: $colorPlaceholder;
      margin-left: 15px;
    }

    .list-item {
      position: relative;
      width: 100%;
      height: 55px;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      padding: 0 20px;
      &:hover {
        background-color: $colorBack;
      }

      .item-avatar {
        width: 35px;
        height: 35px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        font-weight: 500;
        font-size: 16px;
        line-height: 15px;
        text-align: center;
        letter-spacing: 0.03em;
        color: #ffffff;

        &.group {
          border-radius: 5px;
        }
      }

      .item-name {
        flex: 1;
        font-weight: 500;
        font-size: 18px;
        line-height: 20px;
        letter-spacing: -0.01em;
        margin-left: 20px;
        color: $colorText;
      }
    }
  }
}
</style>
